export const errorHandler = (e) => {
 if(e.response?.status === 401) {
    localStorage.removeItem('token');
    window.location.href = '/login';
 }                  
}